import { render, staticRenderFns } from "./cityRegionShow.vue?vue&type=template&id=530253b5&scoped=true&"
import script from "./cityRegionShow.vue?vue&type=script&lang=js&"
export * from "./cityRegionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530253b5",
  null
  
)

export default component.exports